<script setup>
import { router } from '@inertiajs/vue3';
import { ref } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  id: {
    type: [String, Number],
    required: true,
  },
});

const isOpen = ref(false);

const toggle = () => {
    isOpen.value = !isOpen.value;
};

// Transition hooks
const beforeEnter = (el) => {
  el.style.height = '0';
  el.style.overflow = 'hidden';
};

const enter = (el) => {
  el.style.transition = 'height 0.4s ease';
  el.style.height = el.scrollHeight + 'px';
};

const afterEnter = (el) => {
  el.style.height = 'auto'; // Reset height after transition for auto sizing
  el.style.overflow = 'visible';
};

const beforeLeave = (el) => {
  el.style.height = el.scrollHeight + 'px';
  el.style.overflow = 'hidden';
};

const leave = (el) => {
  el.style.transition = 'height 0.4s ease';
  el.style.height = '0';
};

const afterLeave = (el) => {
  el.style.height = '0'; // Reset height for next open
};

// Handle keyboard events for accessibility
const handleKeydown = (event) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    toggle();
  }
};

</script>

<template>

  <div class="accordion">
      <!-- Add button role, aria-expanded, and aria-controls for accessibility -->
      <button
        @click="toggle"
        @keydown="handleKeydown"
        class="accordion-header"
        :aria-expanded="isOpen.toString()"
        :aria-controls="`content-${id}`"
        :id="`accordion-header-${id}`"
      >
        {{ title }}
        <span class="icon" :class="{ 'open': isOpen }"><span class="material-icons-outlined">expand_circle_down</span></span>
      </button>
      <transition @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave" @leave="leave" @after-leave="afterLeave">
        <div
          v-show="isOpen"
          ref="content"
          :id="`content-${id}`"
          class="accordion-content"
          role="region"
          :aria-labelledby="`accordion-header-${id}`"
        >
          <slot></slot>
        </div>
      </transition>
    </div>

  </template>